import { WizardStep, WizardSteps } from '@app/shared/wizard-navigation/model/wizard-step';
import { Action } from '@ngrx/store';

export interface GoToWizardStepPayload {
  step: WizardStep;
  additionalActions: Action[];
  type?: string;
  prefixUrl?: string;
}

export enum WizardNavigationActionTypes {
  InitWizardNavigation = '[WizardNavigation] Init Wizard Navigation',
  GoToStep = '[WizardNavigation] Go To Step',
  GoToNextStep = '[WizardNavigation] Go To Next Step',
  GoToSubStep = '[WizardNavigation] Go To Sub Step',
  MarkAsCompleted = '[WizardNavigation] Mark As Completed',
  MarkCurrentAsCompleted = '[WizardNavigation] Mark Current As Completed',
  ShowStep = '[WizardNavigation] Show Step',
  HideStep = '[WizardNavigation] Hide Step',
  SetActiveStep = '[WizardNavigation] Set Active Step',
  UpdateStep = '[WizardNavigation] Update Step',
  UpdateSubStep = '[WizardNavigation] Update Sub Step',
  GoToStepCancel = '[WizardNavigation] Go to Step Cancel',
  GoToStepFail = '[WizardNavigation] Go to Step Fail',
  ResetWizardState = '[WizardNavigation] Reset Wizard State'
}

export class InitWizardNavigation implements Action {
  readonly type = WizardNavigationActionTypes.InitWizardNavigation;
  constructor(public payload: {steps: WizardSteps; currentStepId?: number; type: string}) {}
}

export class GoToStep implements Action {
  readonly type = WizardNavigationActionTypes.GoToStep;
  constructor(public payload: GoToWizardStepPayload) {}
}

export class GoToStepFail implements Action {
  readonly type = WizardNavigationActionTypes.GoToStepFail;
  constructor(public payload: Error) {}
}

export class GoToStepCancel implements Action {
  readonly type = WizardNavigationActionTypes.GoToStepCancel;
}

export class GoToNextStep implements Action {
  readonly type = WizardNavigationActionTypes.GoToNextStep;
  constructor(public payload: {type: string}) {}
}

export class GoToSubStep implements Action {
  readonly type = WizardNavigationActionTypes.GoToSubStep;
  constructor(public payload: GoToWizardStepPayload) {}
}

export class MarkAsCompleted implements Action {
  readonly type = WizardNavigationActionTypes.MarkAsCompleted;
  constructor(public payload: WizardStep) {}
}

export class MarkCurrentAsCompleted implements Action {
  readonly type = WizardNavigationActionTypes.MarkCurrentAsCompleted;
  constructor(public payload: {type: string}) {}
}

export class ShowStep implements Action {
  readonly type = WizardNavigationActionTypes.ShowStep;
  constructor(public payload: WizardStep) {}
}

export class HideStep implements Action {
  readonly type = WizardNavigationActionTypes.HideStep;
  constructor(public payload: WizardStep) {}
}

export class SetActiveStep implements Action {
  readonly type = WizardNavigationActionTypes.SetActiveStep;
  constructor(public payload: WizardStep) {}
}

export class UpdateStep implements Action {
  readonly type = WizardNavigationActionTypes.UpdateStep;
  constructor(public payload: WizardStep) {}
}

export class UpdateSubStep implements Action {
  readonly type = WizardNavigationActionTypes.UpdateSubStep;
  constructor(public payload: WizardStep) {}
}

export class ResetWizardState implements Action {
  readonly type = WizardNavigationActionTypes.ResetWizardState;
  constructor(public payload: {type: string}) {}
}

export type WizardNavigationActions =
  | InitWizardNavigation
  | GoToStep
  | GoToNextStep
  | GoToSubStep
  | MarkAsCompleted
  | MarkCurrentAsCompleted
  | ShowStep
  | HideStep
  | SetActiveStep
  | UpdateStep
  | UpdateSubStep
  | GoToStepCancel
  | GoToStepFail
  | ResetWizardState;

export function wizardGoToStep(step: WizardStep, additionalActions?: Action[]) {
  return new GoToStep({step, additionalActions});
}

export function wizardGoToSubStep(step: WizardStep, additionalActions: Action[]) {
  return new GoToSubStep({step, additionalActions});
}

export function wizardGoToNextStep(type: string) {
  return new GoToNextStep({type});
}

export function wizardMarkCurrentStepAsCompleted(type: string) {
  return new MarkCurrentAsCompleted({type});
}

export function wizardHideStep(wizardStep: WizardStep) {
  return new HideStep(wizardStep);
}

export function wizardShowStep(wizardStep: WizardStep) {
  return new ShowStep(wizardStep);
}

export function wizardMarkAsCompleted(wizardStep: WizardStep) {
  return new MarkAsCompleted(wizardStep);
}
